import baseApi from './RootBaseApi';
import {
  AdminListValue,
  ListValueQueryParams,
  ManagedListType,
  PublicListValue,
  UpsertListValuePayload,
} from '@/types/list-value.types';

export interface PublicListValueQueryParams {
  type: ManagedListType;
  language?: string;
}

export const ListValueService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAdminListValues: builder.query<AdminListValue[], ListValueQueryParams>({
      query: ({ type, ...params }) => ({
        url: `/list-values/${type}`,
        method: 'GET',
        params,
      }),
      transformResponse: (response: AdminListValue[]) => response,
      providesTags: (_result, _error, { type }) => [
        { type: 'ListValues', id: type },
      ],
    }),
    getPublicListValues: builder.query<
      PublicListValue[],
      PublicListValueQueryParams
    >({
      query: ({ type, language }) => ({
        url: `/list-values/${type}/public`,
        method: 'GET',
        params: language ? { language } : undefined,
      }),
      transformResponse: (response: PublicListValue[]) => response,
      providesTags: (_result, _error, { type }) => [
        { type: 'ListValues', id: type },
      ],
    }),
    createListValue: builder.mutation<
      AdminListValue,
      { type: ManagedListType; data: UpsertListValuePayload }
    >({
      query: ({ type, data }) => ({
        url: `/list-values/${type}`,
        method: 'POST',
        data,
      }),
      invalidatesTags: (_result, _error, { type }) => [
        { type: 'ListValues', id: type },
      ],
    }),
    updateListValue: builder.mutation<
      AdminListValue,
      { type: ManagedListType; id: string; data: Partial<UpsertListValuePayload> }
    >({
      query: ({ type, id, data }) => ({
        url: `/list-values/${type}/${id}`,
        method: 'PATCH',
        data,
      }),
      invalidatesTags: (_result, _error, { type }) => [
        { type: 'ListValues', id: type },
      ],
    }),
    deleteListValue: builder.mutation<
      AdminListValue,
      { type: ManagedListType; id: string }
    >({
      query: ({ type, id }) => ({
        url: `/list-values/${type}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_result, _error, { type }) => [
        { type: 'ListValues', id: type },
      ],
    }),
  }),
});

export const {
  useGetAdminListValuesQuery,
  useGetPublicListValuesQuery,
  useCreateListValueMutation,
  useUpdateListValueMutation,
  useDeleteListValueMutation,
} = ListValueService;
